import React from 'react';

class UserPage extends React.Component {
    state = {
        name: ''
    };

    componentDidMount() {
        this.setState({
            name: this.getName()
        });
    }

    handleChangeInput = (e) => {
        const {name, value} = e.target;
        this.setState({[name]: value});
    };

    getName = () => {
        return localStorage.getItem('name') || '';
    };

    setName = (name) => {
        return localStorage.setItem('name', name);
    };

    handleSave = () => {
        const {name} = this.state;
        this.setName(name);
    };

    render() {
        const {name} = this.state;

        return (
            <div className='UserPage'>
                <input name='name' value={name} onChange={this.handleChangeInput}/>
                <button onClick={this.handleSave}>Save</button>
            </div>
        );
    }
}

export default UserPage;
